module.exports = __webpack_public_path__ + "img/edit.ed9e7ce9.svg";